import React, {DetailedHTMLProps, HTMLAttributes, ReactNode} from 'react';
import styles from './Container.module.scss'
import cn from "classnames";

interface ContainerProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children: ReactNode,
}
const Container = ({children, className, ...props}: ContainerProps) => {
    return (
        <div className={cn(styles.container, className)} {...props}>
            {children}
        </div>
    );
};

export default Container;